import * as types from "../types/orderForEditDetails"

export const addOrderForEditDetails = (orderForEditDetails) => ({
  type: types.ADD_ORDER_FOR_EDIT_DETAILS,
  orderForEditDetails
})

export const deleteOrderForEditDetails = () => ({
  type: types.DELETE_ORDER_FOR_EDIT_DETAILS
})